import React from 'react';
import styled from 'styled-components';
import translate from './TranslateHOC';
import { Link } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import cywTiwbHome from '../img/cyw/cywTiwbHome.svg';
import { CYW_ID, STWNSH_ID } from '../constants';

const ProgrammeIconLink = ({ channel }) => {
  const catId = channel.categoryId;
  const logo =
    catId === CYW_ID || catId === STWNSH_ID
      ? channel.logoImage && channel.logoImage.url
      : channel.iconImage && channel.iconImage.url;
  const logoAlt = channel.title;

  return catId ? (
    <div className="programme-link">
      <div className="programme__inner">
        <Link to={`/Categories/${catId}`}>
          <LogoContainer>
            {catId === CYW_ID && (
              <Isvg
                src={cywTiwbHome}
                className="cyw-tiwb-link__home-icon"
                alt={logoAlt}
              />
            )}
            <img
              src={logo}
              className={
                catId === CYW_ID || catId === STWNSH_ID
                  ? 'programme__logo'
                  : 'programme__logo programme__logo--icon'
              }
              alt={logoAlt}
            />
          </LogoContainer>
        </Link>
      </div>
    </div>
  ) : null;
};

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export default translate(ProgrammeIconLink);
